// import React from 'react';
// import { FaThumbsUp, FaCommentAlt, FaShare } from 'react-icons/fa';
// import { formatCount } from '../utils/postUtils';
// import styles from './PostActions.module.css';
// export default function PostActions({
//   post,
//   onLike,
//   onComment,
//   onShare,
//   isLiking,
//   isSharing,
//   showCommentSection,
//   }) {
//   const isLiked = post?.isLikedByMe;
//   const likes = post?.likesCount || 0;
//   const commentsCount = post?.commentsCount || 0;
//   const shares = post?.sharesCount || 0;

//   return (
//     <div className={styles.actions}>
//       <button
//         className={`${styles.actionBtn} ${isLiked ? styles.liked : ''}`}
//         onClick={onLike}
//         disabled={isLiking}
//         aria-label={isLiked ? 'Unlike post' : 'Like post'}
//       >
//         <FaThumbsUp />
//         <span>{isLiked ? 'Liked' : 'Like'}</span>
//         {likes > 0 && (
//           <span className={styles.count}>{formatCount(likes)}</span>
//         )}
//       </button>

//       <button
//         className={`${styles.actionBtn} ${showCommentSection ? styles.active : ''}`}
//         onClick={onComment}
//         aria-label="Toggle comments"
//       >
//         <FaCommentAlt />
//         <span>Opinion</span>
//         {commentsCount > 0 && (
//           <span className={styles.count}>{formatCount(commentsCount)}</span>
//         )}
//       </button>

//       <button
//         className={styles.actionBtn}
//         onClick={onShare}
//         disabled={isSharing}
//         aria-label="Share post"
//       >
//         <FaShare />
//         <span>{isSharing ? 'Sharing…' : 'Share'}</span>
//         {shares > 0 && (
//           <span className={styles.count}>{formatCount(shares)}</span>
//         )}
//       </button>
//     </div>
//   );
// }

import React from 'react';
import { FaThumbsUp, FaCommentAlt, FaShare, FaBookmark, FaRegBookmark } from 'react-icons/fa';
import { formatCount } from '../utils/postUtils';
import styles from './PostActions.module.css';

// FIX: Added onSave + isSaving props so the Save button is visible
// in the action bar for EVERYONE (not buried in the ··· dropdown for non-owners).
// The ··· dropdown save for non-owners is kept too — both work.

export default function PostActions({
  post,
  onLike,
  onComment,
  onShare,
  onSave,           // NEW
  isLiking,
  isSharing,
  isSaving,         // NEW
  showCommentSection,
}) {
  const isLiked = post?.isLikedByMe;
  const likes = post?.likesCount || 0;
  const commentsCount = post?.commentsCount || 0;
  const shares = post?.sharesCount || 0;
  const isSaved = post?.isSaved;

  return (
    <div className={styles.actions}>
      <button
        className={`${styles.actionBtn} ${isLiked ? styles.liked : ''}`}
        onClick={onLike}
        disabled={isLiking}
        aria-label={isLiked ? 'Unlike post' : 'Like post'}
      >
        <FaThumbsUp />
        <span>{isLiked ? 'Liked' : 'Like'}</span>
        {likes > 0 && (
          <span className={styles.count}>{formatCount(likes)}</span>
        )}
      </button>

      <button
        className={`${styles.actionBtn} ${showCommentSection ? styles.active : ''}`}
        onClick={onComment}
        aria-label="Toggle comments"
      >
        <FaCommentAlt />
        <span>Opinion</span>
        {commentsCount > 0 && (
          <span className={styles.count}>{formatCount(commentsCount)}</span>
        )}
      </button>

      <button
        className={styles.actionBtn}
        onClick={onShare}
        disabled={isSharing}
        aria-label="Share post"
      >
        <FaShare />
        <span>{isSharing ? 'Sharing…' : 'Share'}</span>
        {shares > 0 && (
          <span className={styles.count}>{formatCount(shares)}</span>
        )}
      </button>

      {/* Save button — visible to everyone in the action bar */}
      {onSave && (
        <button
          className={`${styles.actionBtn} ${isSaved ? styles.active : ''}`}
          onClick={onSave}
          disabled={isSaving}
          aria-label={isSaved ? 'Unsave post' : 'Save post'}
        >
          {isSaved ? <FaBookmark /> : <FaRegBookmark />}
          <span>{isSaving ? '...' : isSaved ? 'Saved' : 'Save'}</span>
        </button>
      )}
    </div>
  );
}